import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum bulkBuyerSellersType {
    UPLOAD_BULK_BUYER_SELLERS_FILE = "@@auth/UPLOAD_BULK_BUYER_SELLERS_FILE",
    UPLOAD_BULK_BUYER_SELLERS_FILE_SUCCESS = "@@auth/UPLOAD_BULK_BUYER_SELLERS_FILE_SUCCESS",
    UPLOAD_BULK_BUYER_SELLERS_FILE_ERROR = "@@auth/UPLOAD_BULK_BUYER_SELLERS_FILE_ERROR",
    RESET_UPLOAD_BULK_BUYER_SELLERS_FILE = "@@auth/RESET_UPLOAD_BULK_BUYER_SELLERS_FILE",

    FETCH_BULK_BUYER_SELLERS_FILE = "@@auth/FETCH_BULK_BUYER_SELLERS_FILE",
    FETCH_BULK_BUYER_SELLERS_FILE_SUCCESS = "@@auth/FETCH_BULK_BUYER_SELLERS_FILE_SUCCESS",
    FETCH_BULK_BUYER_SELLERS_FILE_ERROR = "@@auth/FETCH_BULK_BUYER_SELLERS_FILE_ERROR",
    RESET_FETCH_BULK_BUYER_SELLERS_FILE = "@@auth/RESET_FETCH_BULK_BUYER_SELLERS_FILE",

    BULK_BUYER_SELLERS_FILE_DOWNLOAD = "@@auth/BULK_BUYER_SELLERS_FILE_DOWNLOAD",
    BULK_BUYER_SELLERS_FILE_DOWNLOAD_SUCCESS = "@@auth/BULK_BUYER_SELLERS_FILE_DOWNLOAD_SUCCESS",
    BULK_BUYER_SELLERS_FILE_DOWNLOAD_ERROR = "@@auth/BULK_BUYER_SELLERS_FILE_DOWNLOAD_ERROR",
    RESET_BULK_BUYER_SELLERS_FILE_DOWNLOAD = "@@auth/RESET_BULK_BUYER_SELLERS_FILE_DOWNLOAD",

    FETCH_BULK_BUYER_SELLERS_FILE_DETAIL = "@@auth/FETCH_BULK_BUYER_SELLERS_FILE_DETAIL",
    FETCH_BULK_BUYER_SELLERS_FILE_DETAIL_SUCCESS = "@@auth/FETCH_BULK_BUYER_SELLERS_FILE_DETAIL_SUCCESS",
    FETCH_BULK_BUYER_SELLERS_FILE_DETAIL_ERROR = "@@auth/FETCH_BULK_BUYER_SELLERS_FILE_DETAIL_ERROR",
    RESET_FETCH_BULK_BUYER_SELLERS_FILE_DETAIL = "@@auth/RESET_FETCH_BULK_BUYER_SELLERS_FILE_DETAIL",

    BULK_BUYER_SELLERS_FILE_VERSION = "@@auth/BULK_BUYER_SELLERS_FILE_VERSION",
    BULK_BUYER_SELLERS_FILE_VERSION_SUCCESS = "@@auth/BULK_BUYER_SELLERS_FILE_VERSION_SUCCESS",
    BULK_BUYER_SELLERS_FILE_VERSION_ERROR = "@@auth/BULK_BUYER_SELLERS_FILE_VERSION_ERROR",
    RESET_BULK_BUYER_SELLERS_FILE_VERSION = "@@auth/RESET_BULK_BUYER_SELLERS_FILE_VERSION",

    BULK_BUYER_SELLERS_FILE_PUBLISH = "@@auth/BULK_BUYER_SELLERS_FILE_PUBLISH",
    BULK_BUYER_SELLERS_FILE_PUBLISH_SUCCESS = "@@auth/BULK_BUYER_SELLERS_FILE_PUBLISH_SUCCESS",
    BULK_BUYER_SELLERS_FILE_PUBLISH_ERROR = "@@auth/BULK_BUYER_SELLERS_FILE_PUBLISH_ERROR",
    RESET_BULK_BUYER_SELLERS_FILE_PUBLISH = "@@auth/RESET_BULK_BUYER_SELLERS_FILE_PUBLISH",

    APPROVE_BULK_BUYER_SELLERS_FILE = "@@auth/APPROVE_BULK_BUYER_SELLERS_FILE",
    APPROVE_BULK_BUYER_SELLERS_FILE_SUCCESS = "@@auth/APPROVE_BULK_BUYER_SELLERS_FILE_SUCCESS",
    APPROVE_BULK_BUYER_SELLERS_FILE_ERROR = "@@auth/APPROVE_BULK_BUYER_SELLERS_FILE_ERROR",
    RESET_APPROVE_BULK_BUYER_SELLERS_FILE = "@@auth/RESET_APPROVE_BULK_BUYER_SELLERS_FILE",

    REJECT_BULK_BUYER_SELLERS_FILE = "@@auth/REJECT_BULK_BUYER_SELLERS_FILE",
    REJECT_BULK_BUYER_SELLERS_FILE_SUCCESS = "@@auth/REJECT_BULK_BUYER_SELLERS_FILE_SUCCESS",
    REJECT_BULK_BUYER_SELLERS_FILE_ERROR = "@@auth/REJECT_BULK_BUYER_SELLERS_FILE_ERROR",
    RESET_REJECT_BULK_BUYER_SELLERS_FILE = "@@auth/RESET_REJECT_BULK_BUYER_SELLERS_FILE",

    FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS = "@@auth/FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS",
    FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS_SUCCESS = "@@auth/FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS_SUCCESS",
    FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS_ERROR = "@@auth/FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS_ERROR",
    RESET_FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS = "@@auth/RESET_FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS",

    DELETE_BULK_BUYER_SELLERS_FILE = "@@auth/DELETE_BULK_BUYER_SELLERS_FILE",
    DELETE_BULK_BUYER_SELLERS_FILE_SUCCESS = "@@auth/DELETE_BULK_BUYER_SELLERS_FILE_SUCCESS",
    DELETE_BULK_BUYER_SELLERS_FILE_ERROR = "@@auth/DELETE_BULK_BUYER_SELLERS_FILE_ERROR",
    RESET_DELETE_BULK_BUYER_SELLERS_FILE = "@@auth/RESET_DELETE_BULK_BUYER_SELLERS_FILE",
}

// Action Types
export type BulkBuyerSellersAction = {
    type:
    | bulkBuyerSellersType.UPLOAD_BULK_BUYER_SELLERS_FILE
    | bulkBuyerSellersType.RESET_UPLOAD_BULK_BUYER_SELLERS_FILE

    | bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE
    | bulkBuyerSellersType.RESET_FETCH_BULK_BUYER_SELLERS_FILE

    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_DOWNLOAD
    | bulkBuyerSellersType.RESET_BULK_BUYER_SELLERS_FILE_DOWNLOAD

    | bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_DETAIL
    | bulkBuyerSellersType.RESET_FETCH_BULK_BUYER_SELLERS_FILE_DETAIL

    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_VERSION
    | bulkBuyerSellersType.RESET_BULK_BUYER_SELLERS_FILE_VERSION

    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_PUBLISH
    | bulkBuyerSellersType.RESET_BULK_BUYER_SELLERS_FILE_PUBLISH

    | bulkBuyerSellersType.APPROVE_BULK_BUYER_SELLERS_FILE
    | bulkBuyerSellersType.RESET_APPROVE_BULK_BUYER_SELLERS_FILE

    | bulkBuyerSellersType.REJECT_BULK_BUYER_SELLERS_FILE
    | bulkBuyerSellersType.RESET_REJECT_BULK_BUYER_SELLERS_FILE

    | bulkBuyerSellersType.FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS
    | bulkBuyerSellersType.RESET_FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS

    | bulkBuyerSellersType.DELETE_BULK_BUYER_SELLERS_FILE
    | bulkBuyerSellersType.RESET_DELETE_BULK_BUYER_SELLERS_FILE


    payload: any;
};

export type uploadBulkBuyerSellerFile = {
    bulkBuyerSellerFile: File;
    programmeExtId: string
}
export type BulkBuyerSellerDownloadFileType = {
    downloadURL: string
}
export type BulkBulkBuyerSellerFileDetail = {
    externalID: string,
    internalID: string
}
export type BulkBulkBuyerSellerFileVersionType = {
    externalId: string,
    filter: FilterMetadata
}
export type BulkBuyerSellerFileMakerRemarkType = {
    remarkPayload: { makerRemarks: string },
    externalId: string
}
export type BulkBuyerSellerFileCheckerRemarkType = {
    remarkPayload: { checkerRemarks: string },
    externalId: string
}

// Saga Types
export type uploadBulkBuyerSellersFileSaga = {
    type: string,
    payload: uploadBulkBuyerSellerFile
}
export type fetchBulkBuyerSellersFileSaga = {
    type: string,
    payload: FilterMetadata
}
export type downloadBulkBuyerSellersFileSaga = {
    type: string,
    payload: BulkBuyerSellerDownloadFileType
}
export type fetchBulkBuyerSellersFileDetailSaga = {
    type: string,
    payload: BulkBulkBuyerSellerFileDetail
}
export type BulkBuyerSellersFileVersionSaga = {
    type: string,
    payload: BulkBulkBuyerSellerFileVersionType
}
export type BulkBuyerSellersFileMakerRemarkSaga = {
    type: string,
    payload: BulkBuyerSellerFileMakerRemarkType
}

export type BulkBuyerSellersFileCheckerRemarkSaga = {
    type: string,
    payload: BulkBuyerSellerFileCheckerRemarkType
}


// Reducer Types
type reducerPayload = {
    data: FetchApiResponse<any>; // Future option: FetchApiResponse<any> | Record<string, unknown>
    error: string;
}
export type BulkBuyerSellersReducer = {
    type:
    | bulkBuyerSellersType.UPLOAD_BULK_BUYER_SELLERS_FILE
    | bulkBuyerSellersType.UPLOAD_BULK_BUYER_SELLERS_FILE_SUCCESS
    | bulkBuyerSellersType.UPLOAD_BULK_BUYER_SELLERS_FILE_ERROR
    | bulkBuyerSellersType.RESET_UPLOAD_BULK_BUYER_SELLERS_FILE

    | bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE
    | bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_SUCCESS
    | bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_ERROR
    | bulkBuyerSellersType.RESET_FETCH_BULK_BUYER_SELLERS_FILE

    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_DOWNLOAD
    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_DOWNLOAD_SUCCESS
    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_DOWNLOAD_ERROR
    | bulkBuyerSellersType.RESET_BULK_BUYER_SELLERS_FILE_DOWNLOAD

    | bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_DETAIL
    | bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_DETAIL_SUCCESS
    | bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_DETAIL_ERROR
    | bulkBuyerSellersType.RESET_FETCH_BULK_BUYER_SELLERS_FILE_DETAIL

    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_VERSION
    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_VERSION_SUCCESS
    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_VERSION_ERROR
    | bulkBuyerSellersType.RESET_BULK_BUYER_SELLERS_FILE_VERSION


    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_PUBLISH
    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_PUBLISH_SUCCESS
    | bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_PUBLISH_ERROR
    | bulkBuyerSellersType.RESET_BULK_BUYER_SELLERS_FILE_PUBLISH

    | bulkBuyerSellersType.APPROVE_BULK_BUYER_SELLERS_FILE
    | bulkBuyerSellersType.APPROVE_BULK_BUYER_SELLERS_FILE_SUCCESS
    | bulkBuyerSellersType.APPROVE_BULK_BUYER_SELLERS_FILE_ERROR
    | bulkBuyerSellersType.RESET_APPROVE_BULK_BUYER_SELLERS_FILE

    | bulkBuyerSellersType.REJECT_BULK_BUYER_SELLERS_FILE
    | bulkBuyerSellersType.REJECT_BULK_BUYER_SELLERS_FILE_SUCCESS
    | bulkBuyerSellersType.REJECT_BULK_BUYER_SELLERS_FILE_ERROR
    | bulkBuyerSellersType.RESET_REJECT_BULK_BUYER_SELLERS_FILE

    | bulkBuyerSellersType.FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS
    | bulkBuyerSellersType.FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS_SUCCESS
    | bulkBuyerSellersType.FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS_ERROR
    | bulkBuyerSellersType.RESET_FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS

    | bulkBuyerSellersType.DELETE_BULK_BUYER_SELLERS_FILE
    | bulkBuyerSellersType.DELETE_BULK_BUYER_SELLERS_FILE_SUCCESS
    | bulkBuyerSellersType.DELETE_BULK_BUYER_SELLERS_FILE_ERROR
    | bulkBuyerSellersType.RESET_DELETE_BULK_BUYER_SELLERS_FILE

    payload: reducerPayload;
};

export type BulkBuyerSellersReducerStateWithoutListObject = {
    loading?: boolean;
    data?: CreateApiResponse<any>;
    error?: string | null;
};
export type BulkBuyerSellersReducerStateWithListObject = {
    loading?: boolean;
    data?: FetchApiResponse<any>;
    error?: string | null;
};